<a appTooltip="Prossimi adempimenti" placement="bottom" [attr.aria-label]="getAriaLabel()" [appTooltipEnabled]="true" class="dropdown-toggle" (click)="onClick.emit($event)"
    data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{{adempimenti.length}}</a>
<div class="dropdown-menu">
    <h2>Prossimi adempimenti</h2>
    <div *ngIf="adempimenti.length > 0" class="alert_content">
        <ul prossimi-adempimenti-list class="att_completare" [adempimenti]="adempimenti" [slice]="numToView"
            [viewOption]="false">
        </ul>
        <small aria-live="polite" class="sr-only">
           Sono presenti {{adempimenti.length}} prossimi adempimenti 
        </small>
    </div>
    <div *ngIf="adempimenti.length == 0">
        <p class="allinea_centro">Non ci sono adempimenti nei prossimi 7 giorni</p>
        <small aria-live="polite" class="sr-only">
            Non ci sono adempimenti nei prossimi 7 giorni
        </small>
    </div>
    <div class="read_more">
        <a [routerLink]="['/',viewAll]" appTooltip="Vedi tutti i prossimi adempimenti" [appTooltipEnabled]="true">Vedi tutti</a>
    </div>
</div>